import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateBefore',
  standalone: true
})
export class TruncateBeforePipe implements PipeTransform {
  transform(value: string, substring: string, charsToCut: number): string {
    if (!value || !substring || charsToCut < 0) {
      return value;
    }

    const index = value.toLowerCase().indexOf(substring.toLowerCase());
    if (index === -1 || index < charsToCut) {
      return value;
    }

    const start = index - charsToCut;
    return '...' + value.slice(start);
  }
}
